//Инструкция

import React from 'react';
import './Manual.css';
import manual1 from '../../../images/manual1.png';
import manual2 from '../../../images/manual2.png';
import manual3 from '../../../images/manual3.png';
import manual4 from '../../../images/manual4.png';


export function Manual (props) {
  
  return (
    <section className='manual'>
    <h2 className='manual__title font35Bold'>Организуйте план питания в несколько кликов!</h2>
    <div className='manual__content'>
    <div className='manual__step'> 
      <h3 className='manual__subtitle font20Bold'>1. Заполните настройки</h3>
      <img className='manual__image' alt='Заполните настройки' src={manual1} />
     
    </div>
    <div className='manual__step'> 
      <h3 className='manual__subtitle font20Bold'>2. Выберите даты</h3>
      <img className='manual__image' alt='Выберите даты' src={manual2} />
    </div>
    <div className='manual__step'> 
      <h3 className='manual__subtitle font20Bold'>3. Ознакомтесь с планом</h3>
      <img className='manual__image' alt='Ознакомтесь с планом' src={manual3} />
    </div>
    <div className='manual__step'> 
      <h3 className='manual__subtitle font20Bold'>4. Получите список продуктов</h3>
      <img className='manual__image' alt='Получите список продуктов' src={manual4} />
    </div>
    </div>
    </section>
)
   
}